import { useEffect, useState } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from '@/lib/auth';
import { useUserRole } from '@/hooks/useUserRole';

export function useCoachAssignment() {
  const { user } = useAuth();
  const { isClient, loading: roleLoading } = useUserRole();
  const [isAssigned, setIsAssigned] = useState(true); // default true to avoid flash
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (roleLoading) return;

    // Non-client roles bypass the gate
    if (!isClient || !user) {
      setIsAssigned(true);
      setLoading(false);
      return;
    }

    const checkAssignment = async () => {
      const { data, error } = await supabase
        .from('coach_clients')
        .select('id')
        .eq('client_id', user.id)
        .limit(1);

      if (error) {
        console.error('Error checking coach assignment:', error);
        setIsAssigned(false);
      } else {
        setIsAssigned(data && data.length > 0);
      }
      setLoading(false);
    };

    checkAssignment();
  }, [user, isClient, roleLoading]);

  return { isAssigned, loading };
}
